import React from "react";
import { Atom, Broadcast, ShieldCheck, ChatCircleText } from "@phosphor-icons/react";

const BG =
  "https://images.unsplash.com/photo-1780956185049-4edcd20c61f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxwaHlzaWNzJTIwc2NpZW5jZSUyMGRhcmslMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc4MzEwNTMzNHww&ixlib=rb-4.1.0&q=85";

const FEATURES = [
  { icon: ChatCircleText, title: "KI-Chat", text: "Stelle Fragen zu deiner Umgebung – die KI erklärt Physik verständlich." },
  { icon: Broadcast, title: "Echte Sensordaten", text: "Nutze Kamera, Mikrofon, GPS, Bewegungs- und Lichtsensoren deines Geräts." },
  { icon: ShieldCheck, title: "Privacy first", text: "Gemessen wird nur auf deinen Befehl – nie im Hintergrund. Nur Zusammenfassungen werden gesendet." },
];

export default function Onboarding({ onStart }) {
  return (
    <div data-testid="onboarding-screen" className="relative min-h-[100dvh] flex flex-col overflow-hidden">
      <div className="absolute inset-0">
        <img src={BG} alt="" className="w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/85 to-bg" />
      </div>
      <div className="relative z-10 flex-1 flex flex-col justify-end max-w-lg mx-auto w-full p-6 pb-10">
        <div className="flex items-center gap-2 mb-4">
          <Atom size={34} weight="duotone" className="text-volt" />
          <span className="text-xs uppercase tracking-[0.25em] font-bold text-volt">Physik AI</span>
        </div>
        <h1 className="font-heading text-5xl font-black tracking-tight leading-[0.95] mb-3">
          CHAT MIT DEINER<br />
          <span className="text-volt">UMGEBUNG</span>
        </h1>
        <p className="text-muted text-base mb-8">
          Miss deine reale Umwelt mit den Sensoren deines Smartphones und lass die KI erklären, was um dich herum passiert.
        </p>
        <div className="space-y-3 mb-8">
          {FEATURES.map((f) => (
            <div key={f.title} className="flex items-start gap-3 bg-surface/80 backdrop-blur border border-white/10 rounded-xl p-4">
              <f.icon size={22} weight="duotone" className="text-volt mt-0.5 shrink-0" />
              <div>
                <div className="font-semibold text-sm">{f.title}</div>
                <div className="text-muted text-sm">{f.text}</div>
              </div>
            </div>
          ))}
        </div>
        <button
          data-testid="onboarding-start-btn"
          onClick={onStart}
          className="w-full bg-volt hover:bg-volthover active:scale-[0.98] transition-all rounded-xl py-4 font-bold text-lg"
        >
          Los geht's
        </button>
        <p className="text-center text-xs text-muted mt-4">
          10 Standard-Anfragen + 1 Pro-Anfrage geschenkt zum Start
        </p>
      </div>
    </div>
  );
}
